import { Component, OnDestroy, OnInit } from '@angular/core'
import { Subscription } from 'rxjs'
import { TranslocoService } from '@jsverse/transloco'
import { SideNavigationStatusColor } from '../../../../shared/modules/side-navigation-bar/enums/side-navigation-status-color.enum'
import { UpsellStatus } from '../../models/upsell-page.models'
import { UpsellBuilderStepsService } from '../../services/upsell-builder-steps.service'
import { RouteHeaderUrl } from '../../../../shared/components/one-header/header-navigation.model'

@Component({
    templateUrl: './upsell-builder.component.html',
    styleUrls: ['./upsell-builder.component.scss'],
    standalone: false
})
export class UpsellBuilderComponent implements OnInit, OnDestroy {
  headline = ''
  subHeadline = ''
  statusLabel: string = ''
  statusColor = SideNavigationStatusColor.Grey
  backButtonLabel = ''
  backButtonUrl = '/upsell'
  steps$ = this.stepService.steps$
  isSideBarPinned: boolean = false
  RouteHeaderUrl = RouteHeaderUrl
  private subscription$ = new Subscription()
  private lastStatus: UpsellStatus = UpsellStatus.Off

  constructor (
      private stepService: UpsellBuilderStepsService,
      private transloco: TranslocoService,
  ) {}

  ngOnInit(): void {
    this.applyShellI18n()
    this.subscription$.add(
      this.transloco.langChanges$.subscribe(() => this.applyShellI18n())
    )
    this.subscription$.add(
      this.stepService.status$.asObservable().subscribe(status => {
        this.lastStatus = status
        this.applyStatusLabel(status)
        switch (status) {
          case UpsellStatus.Live:
            this.statusColor = SideNavigationStatusColor.Green
            break
          case UpsellStatus.Paused:
            this.statusColor = SideNavigationStatusColor.Yellow
            break
          case UpsellStatus.Off:
            this.statusColor = SideNavigationStatusColor.Grey
            break
          case UpsellStatus.Invalid:
            this.statusColor = SideNavigationStatusColor.Red
            break
        }
      })
    )
  }

  private applyShellI18n() {
    this.headline = this.transloco.translate('upsell_page.builder.headline')
    this.subHeadline = this.transloco.translate('upsell_page.builder.subheadline')
    this.backButtonLabel = this.transloco.translate('upsell_page.builder.back_campaign')
    this.applyStatusLabel(this.lastStatus)
  }

  private applyStatusLabel(status: UpsellStatus) {
    switch (status) {
      case UpsellStatus.Live:
        this.statusLabel = this.transloco.translate('upsell_page.builder.status_live')
        break
      case UpsellStatus.Paused:
        this.statusLabel = this.transloco.translate('upsell_page.builder.status_paused')
        break
      case UpsellStatus.Off:
        this.statusLabel = this.transloco.translate('upsell_page.builder.status_off')
        break
      case UpsellStatus.Invalid:
        this.statusLabel = this.transloco.translate('upsell_page.builder.status_broken')
        break
      default:
        this.statusLabel = String(status)
    }
  }

  ngOnDestroy(): void {
    this.subscription$.unsubscribe()
  }
}
